import { lazyLoad } from '../../index'

export default [
  {
    path: 'boards',
    component: lazyLoad('Admin/Trello/Boards'),
  },
  {
    path: 'board/:boardId',
    component: lazyLoad('Admin/Trello/Board'),
  }

]
